import React, {useState} from 'react'

const BarcodeWizardContext = React.createContext(null)

function BarcodeWizardContextProvider(props) {
  // [A]
  const [entitiesFields, setEntitiesFields] = useState('')
  const [autoGenerateFormValues, setAutoGenerateFormValues] = useState('')
  const [generateFormValue, setGenerateFormValue] = useState('')
  const [createdBarcodeLabel, setCreatedBarcodeLabel] = useState('')

  const value = {
    setEntitiesFields,
    entitiesFields,
    autoGenerateFormValues,
    setAutoGenerateFormValues,
    generateFormValue,
    setGenerateFormValue,
    createdBarcodeLabel,
    setCreatedBarcodeLabel,
  }

  // [B]
  return (
    <BarcodeWizardContext.Provider value={value}>{props.children}</BarcodeWizardContext.Provider>
  )
}

const BarcodeWizardContextConsumer = BarcodeWizardContext.Consumer

export {BarcodeWizardContext, BarcodeWizardContextProvider, BarcodeWizardContextConsumer}
